<template>
  <v-container fluid pa-0>
    <NewGridAtividadesOcorrencias 
      title="Ocorrências"
      :items="ocorrencias"
      :loading="ocorrenciaLoading"
      @aplicaFiltros="aplicaFiltros"
      @changeLayoutSql="changeLayoutSql"
      @paraExecucaoOcorrencia="paraExecucaoOcorrencia"
      @finalizaOcorrenciaModal="abreModalSetarOcorrencia"
    />
    <!-- Modal Setar Ocorrencia -->
    <ModalSetaOcorrencia 
      v-model="dialogOcorrencia"
      :loading="ocorrenciaLoading"
      :atividadeOcorrencia="atividadeOcorrencia"
      @setaOcorrencia="setaOcorrenciaItem"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import NewGridAtividadesOcorrencias from '@/components/atividade/NewGridAtividadesOcorrencias';
import ModalSetaOcorrencia from '@/components/atividade/ModalSetaOcorrencia';
import { changePageTitle } from '../utils/changePageTitle';
import { atividadeService } from '@/domain/atividade/AtividadeService.js';
import { atividadeOcorrenciaService } from '@/domain/atividade/AtividadeOcorrenciaService.js';
import AtividadeOcorrencia from '@/domain/atividade/AtividadeOcorrencia';

export default {
  name: 'AtividadesOcorrenciasView',
  components: {
    NewGridAtividadesOcorrencias,
    ModalSetaOcorrencia
  },
  data() {
    return {
      args: {
        usuario: JSON.parse(localStorage.getItem('user')),
        idLayoutSql: null,
        colaboradores: [],
        status: ['A'],
        dataInicial: null,
        dataFinal: null,
        idRecursoSistema: 100004
      },
      ocorrenciaLoading: false,
      dialogOcorrencia: false,
      atividadeOcorrencia: new AtividadeOcorrencia()

    }
  },
  computed: {
    ...mapGetters(["user", "ocorrencias"])
  },
  methods: {
    ...mapMutations(["showNotification", "closeNotification"]),
    ...mapActions([
      "fetchOcorrenciasSql",
      "fetchOcorrenciasPeriodoSql",
      "fetchLayoutsSqlUsuario",
      "fetchColaboradores"
    ]),
    changeLayoutSql(payload) {
      this.args.idLayoutSql = payload;
    },
    async aplicaFiltros(payload) {
      this.ocorrenciaLoading = true;
      if (payload && payload.dataInicial && payload.dataFinal) {
        this.args.dataInicial = this.moment(payload.dataInicial).format('YYYY-MM-DD');
        this.args.dataFinal = this.moment(payload.dataFinal).format('YYYY-MM-DD');
        await this.fetchOcorrenciasPeriodoSql(this.args);
      } else {
        this.args.dataInicial = null;
        this.args.dataFinal = null;
        await this.fetchOcorrenciasSql(this.args);
      }
      await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100004 });
      await this.fetchColaboradores();
      this.ocorrenciaLoading = false;
    },
    async paraExecucaoOcorrencia(ocorrencia) {
      if (confirm(`Deseja parar a execução da atividade: ${ocorrencia.Atividade}?`)) {
        try {
          await atividadeService.pausarAtividade(ocorrencia.IdAtividade, ocorrencia.IdOcorrencia);
          if (this.args.dataInicial && this.args.dataFinal) {
            await this.fetchOcorrenciasPeriodoSql(this.args);
          } else {
            await this.fetchOcorrenciasSql(this.args);
          }
          this.showNotification({ text: 'Operação realizada com sucesso', status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Operação cancelada', status: 'error' });
      }
    },
    async abreModalSetarOcorrencia(ocorrencia) {
      this.atividadeOcorrencia = { ...ocorrencia };
      this.atividadeOcorrencia.Descricao = '';
      this.dialogOcorrencia = true;
    },
    async setaOcorrenciaItem(ocorrencia) {
      this.ocorrenciaLoading = true;
      try {
        await atividadeOcorrenciaService.finalizarAtividadeOcorrencia(ocorrencia)
        this.dialogOcorrencia = false;
        this.atividadeOcorrencia = new AtividadeOcorrencia();
        this.ocorrenciaLoading = false;
        if (this.args.dataInicial && this.args.dataFinal) {
          await this.fetchOcorrenciasPeriodoSql(this.args);
        } else {
          await this.fetchOcorrenciasSql(this.args);
        }
        this.showNotification({ text: 'Ocorrência finalizada com sucesso.', status: 'success' });
      } catch (error) {
        const text = error.response.data.error;
        this.showNotification({ text, status: 'error' });
        this.ocorrenciaLoading = false;
      }
    }
  },
  created() {
    changePageTitle('Ocorrências');
  }
}
</script>

<style>

</style>